import { ChartStyleConf } from "../types/config";
import { DeepPartial } from "../types/utils";
const heightMD = 800;
const widthWide = 2560;
const widthReallyWide = 3800;
const heightReallyBig = 2160;

export const specifyResponsiveStyles =
    <StyleConf extends object = ChartStyleConf>(
        normal: DeepPartial<StyleConf>,
        small: DeepPartial<StyleConf> = normal,
        wide: DeepPartial<StyleConf> = normal,
        reallyWide: DeepPartial<StyleConf> = wide
    ) =>
        (w: number, h: number, vw: number, vh: number) => {
            if(vh <= heightMD)  
                return small;
            if(vw >= widthReallyWide && vh >= heightReallyBig)
                return reallyWide;            
            if(vw >= widthWide)
                return wide;
            return normal;
        };